function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRisechain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 450,
    height: 156,
    viewBox: "0 0 450 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M90.232 0.391113H0V26.2604H90.232C97.3505 26.2604 103.122 32.0525 103.122 39.1954V52.1304H39.462C17.6676 52.1304 0 69.7977 0 91.5923V155.608H25.7807V94.7762L91.0249 155.605H128.909L45.6636 77.9997H103.122V52.2563H128.909V39.1954C128.909 17.7643 111.588 0.391113 90.232 0.391113Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.626 0.391113H147.734V155.608H173.626V0.391113Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.593 51.8245C192.593 73.2556 209.914 90.6287 231.27 90.6287H274.933C282.052 90.6287 287.823 96.4607 287.823 103.604L287.823 116.804C287.823 123.947 282.051 129.739 274.932 129.739H192.593V155.608H274.932C296.288 155.608 313.609 138.235 313.609 116.804L313.61 103.604C313.61 82.1731 296.289 64.7999 274.933 64.7999H231.27C224.151 64.7999 218.38 58.9679 218.38 51.8245L218.38 39.1954C218.38 32.0525 224.152 26.2604 231.271 26.2604H305.718V0.391113H231.271C209.915 0.391113 192.593 17.7643 192.593 39.1954L192.593 51.8245Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.039 39.1954L328.038 52.2563H353.825L353.825 39.1954C353.825 32.0525 359.597 26.2604 366.716 26.2604H449.949V0.391113H366.716C345.36 0.391113 328.039 17.7643 328.039 39.1954Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.609 64.7999H441.182V90.6287L367.609 90.6692C360.49 90.6692 354.719 96.4607 354.719 103.604L354.719 116.805C354.719 123.947 360.491 129.739 367.61 129.739H449.949V155.609H367.61C346.254 155.609 328.932 138.235 328.932 116.805L328.932 103.604C328.932 82.1724 346.253 64.7999 367.609 64.7999Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRisechain);
export default __webpack_public_path__ + "static/media/risechain.75273df849eee035f05c3c36ee7041ad.svg";
export { ForwardRef as ReactComponent };